import React, { Fragment } from 'react';
import { SvgIcon, SvgIconProps } from 'common/components';

export default function MenuRightTwoTone(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <Fragment>
        <path d="M10,17L15,12L10,7V17Z" />
      </Fragment>
    </SvgIcon>
  );
}
